import { isNullOrUndefined } from "src/utils/objects";

export const getMinMaxQueryParams = (
  min: number | undefined,
  max: number | undefined,
  minRangeValue?: number,
  maxRangeValue?: number
): string[] => {
  const queryParams: string[] = [];
  if (!isNullOrUndefined(min) && typeof min === 'number' && !isNaN(min) && min !== minRangeValue) {
    queryParams.push(`gte:${min}`);
  }
  if (!isNullOrUndefined(max) && typeof max === 'number' && !isNaN(max) && max !== maxRangeValue) {
    queryParams.push(`lte:${max}`);
  }
  return queryParams;
};